import React, { ReactElement } from 'react';
import { getClassNameFactory, InlineErrorMessage } from '@dcl/ui';
import './ErrorBox.css';
import { constant } from './constant';

const ErrorBox = (): ReactElement => {
  const getClassName = getClassNameFactory(ErrorBox.displayName);
  return (
    <div className={getClassName()} data-testid="error-btn">
      <InlineErrorMessage id="errorBox" errorMessage={constant.errorMessage} />
    </div>
  );
};

ErrorBox.displayName = 'ErrorBox';
export default ErrorBox;
